/* Atelier · Pop up Sevilla: estado del pop up en vivo con la hora de Madrid, el día de hoy marcado en el horario,
   los vídeos en bucle (arrancan al verse, respetan «reducir movimiento» y el ahorro de datos), el visor del photocall
   y el voto del próximo pop up. Sin este fichero la página enseña las fechas, el horario, las portadas y las fotos. */
(() => {
  const SCHEDULE = {
    '2026-09-22': ['18:00', '23:00'], '2026-09-23': ['12:00', '22:00'], '2026-09-24': ['12:00', '22:00'],
    '2026-09-25': ['12:00', '22:00'], '2026-09-26': ['10:00', '22:00'], '2026-09-27': ['10:00', '22:00'],
    '2026-09-28': ['12:00', '22:00'], '2026-09-29': ['12:00', '22:00']
  };
  const TEXT = {
    es: { open: (c) => `Abierto ahora · hasta las ${c}`, today: (o) => `Abre hoy a las ${o}`, tomorrow: (o) => `Cerrado · mañana a las ${o}`,
          next: (d, o) => `Abre el ${d} a las ${o}`, finished: 'El pop up ha terminado', weekday: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'] },
    en: { open: (c) => `Open now · until ${c}`, today: (o) => `Opens today at ${o}`, tomorrow: (o) => `Closed · opens tomorrow at ${o}`,
          next: (d, o) => `Opens ${d} at ${o}`, finished: 'The pop up has ended', weekday: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] }
  };

  // Fecha y hora actuales en Madrid, en formato comparable: 'YYYY-MM-DD' y 'HH:MM'.
  function madridNow() {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).map((p) => [p.type, p.value]));
    return { date: `${parts.year}-${parts.month}-${parts.day}`, time: `${parts.hour === '24' ? '00' : parts.hour}:${parts.minute}` };
  }

  function weekdayOf(date, t) {
    const [y, m, d] = date.split('-').map(Number);
    return t.weekday[new Date(Date.UTC(y, m - 1, d, 12)).getUTCDay()];
  }

  // Horario propio de un elemento (data-schedule con JSON {"AAAA-MM-DD":["HH:MM","HH:MM"]}); si no lo trae, el general.
  function scheduleOf(el) {
    try { const s = el && el.dataset.schedule ? JSON.parse(el.dataset.schedule) : null; return s && Object.keys(s).length ? s : SCHEDULE; } catch (e) { return SCHEDULE; }
  }

  // Sin fecha de cierre desde el 29-09-2026: fuera de las fechas de SCHEDULE manda el horario semanal (0 = domingo, 6 = sábado). L-V 12-22 y S-D 10-22, pendiente de confirmar con Hugo.
  const WEEK = [['10:00', '22:00'], ['12:00', '22:00'], ['12:00', '22:00'], ['12:00', '22:00'], ['12:00', '22:00'], ['12:00', '22:00'], ['10:00', '22:00']];
  function hoursOn(date, S) {
    if (S[date]) return S[date];
    const [y, m, d] = date.split('-').map(Number);
    return WEEK[new Date(Date.UTC(y, m - 1, d, 12)).getUTCDay()];
  }

  function status(t, sched) {
    const S = sched || SCHEDULE;
    const now = madridNow();
    const today = hoursOn(now.date, S);
    if (now.time < today[0]) return { state: 'soon', text: t.today(today[0]) };
    if (now.time < today[1]) return { state: 'open', text: t.open(today[1]) };
    const [y, m, d] = now.date.split('-').map(Number);
    const tomorrow = new Date(Date.UTC(y, m - 1, d + 1, 12)).toISOString().slice(0, 10);
    return { state: 'closed', text: t.tomorrow(hoursOn(tomorrow, S)[0]) };
  }

  function update() {
    document.querySelectorAll('[data-n26-status]').forEach((el) => {
      if (el.dataset.state === 'finished') return;
      const t = TEXT[el.dataset.lang] || TEXT.en;
      const s = status(t, scheduleOf(el));
      el.dataset.state = s.state;
      const label = el.querySelector('[data-n26-status-text]');
      if (label && label.textContent !== s.text) label.textContent = s.text;
    });
    const now = madridNow();
    document.querySelectorAll('[data-n26-days] .n26-day').forEach((li) => {
      const d = li.dataset.date;
      const isToday = d === now.date && now.time < li.dataset.close;
      li.classList.toggle('is-today', isToday);
      li.classList.toggle('is-past', d < now.date || (d === now.date && now.time >= li.dataset.close));
      if (isToday) li.setAttribute('aria-current', 'date'); else li.removeAttribute('aria-current');
    });
  }

  // El próximo pop up: suscribe en Klaviyo (lista de la sección) y registra la ciudad como evento con propiedades de perfil.
  // Si Klaviyo no responde (bloqueadores, red), se envía el formulario de Shopify tal cual: alta con marketing y etiquetas.
  // Devuelve 'ok', 'error' (Klaviyo respondió con fallo: se avisa y se puede reintentar) o 'blocked' (no hay red hacia Klaviyo).
  async function sendKlaviyo(company, list, email, city, slug, lang) {
    if (!company || !list) return 'blocked';
    const H = { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2025-10-15' };
    const base = 'https://a.klaviyo.com/client/';
    const q = `?company_id=${encodeURIComponent(company)}`;
    const source = 'La Nocturna · Sevilla 2026';
    try {
      const sub = await fetch(`${base}subscriptions/${q}`, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'subscription',
        attributes: { custom_source: 'Pop up · próximo (La Nocturna)', profile: { data: { type: 'profile', attributes: { email } } } },
        relationships: { list: { data: { type: 'list', id: list } } } } }) });
      if (!sub.ok) { console.warn('Klaviyo', sub.status, await sub.text().catch(() => '')); return 'error'; }
      const properties = { popup_next_city: city, popup_next_city_slug: slug, popup_waitlist: true, popup_waitlist_source: source };
      await fetch(`${base}events/${q}`, { method: 'POST', headers: H, keepalive: true, body: JSON.stringify({ data: { type: 'event',
        attributes: { properties: { city, city_slug: slug, source, language: lang },
          metric: { data: { type: 'metric', attributes: { name: 'Pop Up Waitlist' } } },
          profile: { data: { type: 'profile', attributes: { email, properties } } } } } }) }).catch(() => {});
      return 'ok';
    } catch (e) { console.warn('Klaviyo bloqueado', e); return 'blocked'; }
  }

  function setupNext(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    const box = form;
    const native = document.getElementById('N26NextNative');
    const msg = box.querySelector('[data-n26-next-msg]');
    const other = box.querySelector('[data-n26-other]');
    const otherInput = box.querySelector('[data-n26-other-input]');
    const otherRadio = box.querySelector('[data-n26-other-radio]');
    const mail = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const say = (text, error) => { msg.textContent = text || ''; msg.classList.toggle('is-error', !!error); };
    const slugify = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
    box.addEventListener('change', (e) => {
      if (e.target.name !== 'n26_city') return;
      const isOther = e.target === otherRadio;
      other.hidden = !isOther;
      if (isOther) otherInput.focus();
      say('');
    });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const picked = box.querySelector('input[name="n26_city"]:checked');
      let city = picked ? picked.dataset.city || '' : '';
      let slug = picked ? picked.value : '';
      if (picked && picked === otherRadio) { city = otherInput.value.trim(); slug = slugify(city); }
      if (!picked || !city) { say(box.dataset.tNeedCity, true); (picked ? otherInput : box.querySelector('input[name="n26_city"]')).focus(); return; }
      const email = mail.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(box.dataset.tNeedMail, true); mail.focus(); return; }
      button.disabled = true;
      say(box.dataset.tSending);
      const result = await sendKlaviyo(box.dataset.klaviyo, box.dataset.list, email, city, slug, box.dataset.lang);
      if (result === 'ok') {
        const done = document.createElement('p');
        done.className = 'n26-next-done';
        done.setAttribute('role', 'status');
        done.textContent = `${box.dataset.tDone} ${box.dataset.tDoneCity.replace('{city}', city)}`;
        box.replaceWith(done);
        try { localStorage.setItem('tn-popup-waitlist', slug); } catch (err) {}
      } else if (result === 'error') {
        button.disabled = false;
        say(box.dataset.tError, true);
      } else if (native) {
        native.querySelector('[data-n26-native-email]').value = email;
        native.querySelector('[data-n26-native-tags]').value = `popup-proximo, popup-ciudad-${slug || 'otra'}`;
        HTMLFormElement.prototype.submit.call(native);
      } else {
        button.disabled = false;
        say(box.dataset.tError, true);
      }
    });
  }


  // Vídeos en bucle sin sonido: se cargan después de la página, suenan solo a la vista y se pausan al salir o con su botón.
  // Con «reducir movimiento» o ahorro de datos se quedan en la portada hasta que se pulsa el botón.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  function setupLoop(box) {
    const video = box.querySelector('video[data-n26-loop]');
    const toggle = box.querySelector('[data-n26-toggle]');
    if (!video || box.dataset.loopReady) return;
    box.dataset.loopReady = '1';
    let userPaused = reduceMotion.matches || saveData;
    const pickSrc = () => (window.matchMedia('(min-width: 990px)').matches && video.dataset.srcLarge) || video.dataset.src;
    const sync = () => { if (toggle) toggle.dataset.state = video.paused ? 'paused' : 'playing'; };
    const play = () => {
      if (!video.getAttribute('src')) video.src = pickSrc();
      const p = video.play();
      if (p && p.catch) p.catch(sync);
    };
    video.addEventListener('playing', () => { box.classList.add('is-playing'); sync(); });
    video.addEventListener('pause', sync);
    if (toggle) {
      toggle.hidden = false;
      sync();
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      });
    }
    let inView = false;
    const observe = () => {
      if (!('IntersectionObserver' in window)) { inView = true; if (!userPaused) play(); return; }
      new IntersectionObserver((entries) => {
        inView = entries[entries.length - 1].isIntersecting;
        if (inView && !userPaused) play();
        else if (!inView && !video.paused) video.pause();
      }, { rootMargin: '120px 0px' }).observe(box);
    };
    // Al volver a la pestaña, el navegador puede haber pausado el bucle: se retoma si se ve y nadie lo ha parado.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && inView && !userPaused && video.paused) play();
    });
    if (document.readyState === 'complete') observe();
    else window.addEventListener('load', observe, { once: true });
  }

  // Photocall: visor a pantalla completa con anterior/siguiente (botones, flechas y deslizar), descarga, compartir
  // y enlace directo a cada foto (#foto-12). En iPhone «Guardar» abre la hoja de compartir, que es la que guarda en Fotos.
  function setupPhotocall(list) {
    if (list.dataset.ready) return;
    list.dataset.ready = '1';
    const section = list.closest('section');
    const dialog = section && section.querySelector('[data-n26-lb]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const items = Array.from(list.querySelectorAll('[data-n26-pc-item]'));
    if (!items.length) return;
    const img = dialog.querySelector('[data-n26-lb-img]');
    const count = dialog.querySelector('[data-n26-lb-count]');
    const msg = dialog.querySelector('[data-n26-lb-msg]');
    const stage = dialog.querySelector('[data-n26-lb-stage]');
    const btnDownload = dialog.querySelector('[data-n26-lb-download]');
    const btnShare = dialog.querySelector('[data-n26-lb-share]');
    const tagText = msg ? msg.textContent : '';
    const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 1);
    if (isIOS && list.dataset.tSave) btnDownload.textContent = list.dataset.tSave;
    const blobs = new Map();
    let index = 0;
    let lastFocus = null;

    const say = (text) => { if (msg) msg.textContent = text || tagText; };
    const fileName = (i) => `${list.dataset.name || 'foto'}-${String(i + 1).padStart(2, '0')}.jpg`;
    const sized = (src, w) => `${src}${src.includes('?') ? '&' : '?'}width=${w}`;
    const bestWidth = (item) => {
      const ratio = parseFloat(item.dataset.ratio) || 1.5;
      const box = stage.getBoundingClientRect();
      const css = Math.min(box.width, box.height * ratio) || window.innerWidth;
      const need = css * Math.min(window.devicePixelRatio || 1, 2.5);
      return [800, 1200, 1600, 2000, 2400].find((w) => w >= need) || 2400;
    };
    const blobFor = (i) => {
      if (!blobs.has(i)) {
        const p = fetch(items[i].dataset.src, { mode: 'cors' }).then((r) => { if (!r.ok) throw new Error(r.status); return r.blob(); });
        p.catch(() => blobs.delete(i));
        blobs.set(i, p);
      }
      return blobs.get(i);
    };
    const preload = (i) => { if (i >= 0 && i < items.length) { const pre = new Image(); pre.src = sized(items[i].dataset.src, bestWidth(items[i])); } };

    // Primero la miniatura que ya está cargada (sale al instante) y, en cuanto llega, la versión grande.
    function render(i) {
      index = (i + items.length) % items.length;
      const current = index;
      const item = items[index];
      const thumb = item.querySelector('img');
      const large = sized(item.dataset.src, bestWidth(item));
      img.width = 1600;
      img.height = Math.round(1600 / (parseFloat(item.dataset.ratio) || 1.5));
      img.alt = item.dataset.alt || '';
      if (thumb && thumb.complete && thumb.currentSrc) {
        img.src = thumb.currentSrc;
        const pre = new Image();
        pre.onload = () => { if (index === current) img.src = large; };
        pre.src = large;
      } else {
        img.src = large;
      }
      count.textContent = `${index + 1} ${list.dataset.tOf || '/'} ${items.length}`;
      say('');
      preload(index + 1);
      preload(index - 1);
    }
    function open(i, fromHistory) {
      render(i);
      const hash = `#foto-${index + 1}`;
      if (!dialog.open) {
        lastFocus = items[index];
        dialog.showModal();
        document.documentElement.classList.add('n26-lb-open');
        if (!fromHistory) history.pushState({ n26lb: 1 }, '', hash);
      } else {
        history.replaceState({ n26lb: 1 }, '', hash);
      }
    }
    function requestClose() {
      if (history.state && history.state.n26lb) history.back();
      else dialog.close();
    }
    const go = (step) => { if (dialog.open) { render(index + step); history.replaceState({ n26lb: 1 }, '', `#foto-${index + 1}`); } };

    items.forEach((a, i) => a.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      open(i);
    }));
    dialog.querySelector('[data-n26-lb-close]').addEventListener('click', requestClose);
    dialog.querySelector('[data-n26-lb-prev]').addEventListener('click', () => go(-1));
    dialog.querySelector('[data-n26-lb-next]').addEventListener('click', () => go(1));
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); requestClose(); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('n26-lb-open');
      if (/^#foto-\d+$/.test(location.hash)) history.replaceState(null, '', '#fotos');
      const back = items[index] || lastFocus;
      if (back) back.focus({ preventScroll: false });
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    dialog.addEventListener('click', (e) => { if (e.target === stage) requestClose(); });
    window.addEventListener('popstate', () => {
      const m = location.hash.match(/^#foto-(\d+)$/);
      if (dialog.open && !(history.state && history.state.n26lb)) dialog.close();
      else if (!dialog.open && m && history.state && history.state.n26lb) open(Number(m[1]) - 1, true);
    });

    let startX = 0; let startY = 0; let tracking = false;
    stage.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; tracking = true; startX = e.clientX; startY = e.clientY; });
    stage.addEventListener('pointerup', (e) => {
      if (!tracking) return;
      tracking = false;
      const dx = e.clientX - startX; const dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? 1 : -1);
    });
    stage.addEventListener('pointercancel', () => { tracking = false; });

    async function download() {
      const i = index;
      try {
        const blob = await blobFor(i);
        const file = new File([blob], fileName(i), { type: blob.type || 'image/jpeg' });
        if (isIOS && navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file] });
          return;
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = fileName(i);
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 4000);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        say(list.dataset.tFailed);
        window.open(items[i].dataset.src, '_blank', 'noopener');
      }
    }
    async function share() {
      const i = index;
      const link = `${location.origin}${location.pathname}#foto-${i + 1}`;
      const text = list.dataset.tShareText || document.title;
      try {
        if (navigator.canShare) {
          const blob = await blobFor(i);
          const file = new File([blob], fileName(i), { type: blob.type || 'image/jpeg' });
          if (navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text: `${text} ${link}` }); return; }
        }
        if (navigator.share) { await navigator.share({ title: text, url: link }); return; }
        await navigator.clipboard.writeText(link);
        say(list.dataset.tCopied);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        try { await navigator.clipboard.writeText(link); say(list.dataset.tCopied); } catch (e2) { say(list.dataset.tFailed); }
      }
    }
    btnDownload.addEventListener('click', download);
    btnShare.addEventListener('click', share);
    btnDownload.addEventListener('pointerenter', () => blobFor(index), { passive: true });
    btnShare.addEventListener('pointerenter', () => blobFor(index), { passive: true });
    dialog.addEventListener('pointerdown', (e) => { if (e.target === btnDownload || e.target === btnShare) blobFor(index); }, { passive: true });

    const deep = location.hash.match(/^#foto-(\d+)$/);
    if (deep) {
      const n = Number(deep[1]) - 1;
      if (n >= 0 && n < items.length) {
        history.replaceState(null, '', '#fotos');
        open(n);
      }
    }
  }

  function init() {
    update();
    document.querySelectorAll('[data-n26-next]').forEach(setupNext);
    document.querySelectorAll('[data-n26-loop-box]').forEach(setupLoop);
    document.querySelectorAll('[data-n26-pc]').forEach(setupPhotocall);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setInterval(update, 60000);
  document.addEventListener('shopify:section:load', init);
})();
